import { createIdSlice } from '../utils/action/createElementSlice';
const DefaultState = {
    hideZoomControls: false,
    zoomInEnabled: false,
    zoomOutEnabled: false,
};
export const ZoomState = createIdSlice({
    elementName: 'zoom',
    initialState: {},
    reducers: {
        toggleZoomControls(state = DefaultState) {
            return Object.assign(Object.assign({}, state), { hideZoomControls: !state.hideZoomControls });
        },
        setZoomCapabilities(state = DefaultState, action) {
            return Object.assign(Object.assign({}, state), { zoomInEnabled: action.payload.data.zoomInEnabled, zoomOutEnabled: action.payload.data.zoomOutEnabled });
        },
        zoomIn(state) {
            return state;
        },
        zoomOut(state) {
            return state;
        },
        resetZoom(state) {
            return state;
        },
    },
});
